import { Pipe, PipeTransform } from '@angular/core';
import type { UntypedFormArray, UntypedFormGroup } from '@angular/forms';

@Pipe({
  name: 'getFloorFGAt',
  standalone: false,
})
export class GetFloorFGPipe implements PipeTransform {
  transform(formArray: UntypedFormArray, index: number): UntypedFormGroup {
    return formArray != null ? (formArray.at(index) as UntypedFormGroup) : undefined;
  }
}
